// src/hooks/useLocalStorageToggle.ts
import { useState } from "react";

/**
 * Minimal helper for boolean toggles persisted in localStorage.
 */
export function useLocalStorageToggle(key: string, defaultFalse = false): [boolean, () => void] {
  const [value, setValue] = useState<boolean>(() => {
    try {
      const v = localStorage.getItem(key);
      return v === "1" ? true : v === "0" ? false : !!(!defaultFalse);
    } catch {
      return !defaultFalse;
    }
  });

  const toggle = () => {
    setValue((cur) => {
      const next = !cur;
      try { localStorage.setItem(key, next ? "1" : "0"); } catch {}
      return next;
    });
  };

  return [value, toggle];
}
